import { action, observable, toJS } from 'mobx';
import NGLTeamDailyReportAPI from '../services/ngl-team-daily-report-service';
import { AppConstants, Types } from '../../../common/APIConstants';
import moment from 'moment';
import _ from 'lodash';
import RestEndPoint from '../../../common/RestEndPoint';
class NGLTeamDailyReportStore {
  @observable screenRowData = {
    DailyReportInfo: [],
    Production: [],
    PreviousDayReRun: [],
    C2Blending: [],
    C3Blending: [],
    ProductSpec: [],
    FlareGasCompressorInfo: [],
    TowerKPI: [],
    Incident: []
  };
  @observable screenColumnDefinitions = {
    DailyReportInfo: [],
    Production: [],
    PreviousDayReRun: [],
    C2Blending: [],
    C3Blending: [],
    ProductSpec: [],
    FlareGasCompressorInfo: [],
    TowerKPI: [],
    Incident: []
  };
  @observable headerDetails = {
    startDateTime: '',
    endDateTime: moment().format("MM/DD/YYYY"),
    maxAmbientTemp: '',
    minAmbientTemp: ''
  };

  @observable safetyMoment = null;
  @observable actionItemReview = null;
  @observable hasScreenData = false;

  getScreenData = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    try {
      let requestObj = {
        "DateFilterValue": moment(this.headerDetails.endDateTime).format("MM/DD/YYYY"),
        "ScreenDetails": currentScreenChildren
      };
      const { data } = await NGLTeamDailyReportAPI.getScreenData(requestObj);
      this.safetyMoment = null;
      this.actionItemReview = null;

      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;

        this.screenColumnDefinitions[child.screen.name] = [];
        this.screenRowData[child.screen.name] = [];

        this.screenColumnDefinitions[child.screen.name] = this.getAllColumnDefinitions(screen, columns);
        this.screenRowData[child.screen.name] = data[child.screen.name];
      });

      const dailyReportInfo = this.screenRowData.DailyReportInfo[0];
      this.headerDetails.startDateTime = moment(dailyReportInfo.StartDateTime).format("MM/DD/YYYY HH:mm");
      this.headerDetails.endDateTime = moment(dailyReportInfo.EndDateTime).format("MM/DD/YYYY HH:mm");
      this.headerDetails.currentDateTime = moment(dailyReportInfo.InstantDateTime).format("MM/DD/YYYY HH:mm");
      this.headerDetails.maxAmbientTemp = dailyReportInfo.MaxAmbientTemp + ' ' + dailyReportInfo.AmbientTempUnitAbbv
      this.headerDetails.minAmbientTemp = dailyReportInfo.MinAmbientTemp + ' ' + dailyReportInfo.AmbientTempUnitAbbv

      this.safetyMoment = dailyReportInfo.SafetyMoment;
      this.actionItemReview = dailyReportInfo.ActionItemReview;

      this.hasScreenData = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available for selected date")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  saveScreenData = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const saveObj = [];
      currentScreenChildren.forEach((screenDetail) => {
        const saveScreen = {};
        Object.assign(saveScreen, screenDetail);
        saveScreen.data = this.screenRowData[screenDetail.screen.name];

        if (screenDetail.screen.name === "DailyReportInfo") {
          saveScreen.data[0].SafetyMoment = this.safetyMoment;
          saveScreen.data[0].ActionItemReview = this.actionItemReview;
          saveScreen.data[0].UpdatedBy = RestEndPoint.getCurrentUserEmail();
          saveScreen.data[0].UpdatedOn = moment().format();
        }

        saveObj.push(saveScreen);
      })
      await NGLTeamDailyReportAPI.saveScreenData(saveObj);
      window.toastr.success(AppConstants.TOASTER_SUCCESS);
      CommonStore.toggleLoader();
    }
    catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: 'text',
        hide: column.hidden,
        width: column.width ? column.width : 200,
        keyCreator: (params) => { return this.getValueFomatter(params, column, screen) ? this.getValueFomatter(params, column, screen) : params.value },
        editable: (params) => { return this.getIsEditable(params, column, screen) },
        cellClassRules: {
          'highlight-cell': (params) => { return this.getIsEditable(params, column, screen) },
          'grid-cell-custom': (params) => { return params.data ? true : false }
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) => this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => { return this.getValueFomatter(params, column, screen) }
      });
    });
    return gridColumns;
  };

  getIsEditable(params, column, screen) {

    if (this.getIsDataReadOnly() || !params.data)
      return false;

    if (screen.name === "Production" && column.name === "TargetValue" && params.node.data.Parameter === "Upgrader Fd") {
      return true;
    }
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {

    /* Uncomment any of this to disable the editing on screen for past dates OR a week before */
    
    // return moment(this.headerDetails.endDateTime).isBefore(moment(), "day");
    // return moment(this.headerDetails.endDateTime).isBefore(moment().subtract(7, "days"), "day");

    return false;
  }

  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return 'booleanCellEditor';
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return 'SmartSelectClearable';
    }
  }
  getCellEditorParams(column, params) {

    switch (column.type) {
      case Types.DROPDOWN:
        return {values: column.refLookupData?.lookupValues.values, isPopup: true};
    }
  }

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(column.refLookupData.lookupValues, params.value);
      }

      if (screen.name === "ProductSpec" && (column.name === "DailyAvgValue" || column.name === "InstantValue")) {
        return (params.node.data.Parameter === "C3 Treater Moisture" && params.value == "99") ? "Bypassed" : params.value;
      }
    }
  }

  lookupValue(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value == key)) return null;
    else {
      let label = mappings.values.find(item => item.value == key).label;
      return label;
    }
  }
}

export default new NGLTeamDailyReportStore();